import { render } from "./positions-and-education.vue?vue&type=template&id=8bbb7186"
import script from "./positions-and-education.vue?vue&type=script&lang=js"
export * from "./positions-and-education.vue?vue&type=script&lang=js"

import "./positions-and-education.vue?vue&type=style&index=0&id=8bbb7186&lang=css"
script.render = render

export default script